import { render, staticRenderFns } from "./MoonpayCurrencyListTable.vue?vue&type=template&id=1a7d418d&"
import script from "./MoonpayCurrencyListTable.vue?vue&type=script&lang=js&"
export * from "./MoonpayCurrencyListTable.vue?vue&type=script&lang=js&"
import style0 from "./MoonpayCurrencyListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports